import React from 'react'
import { X } from 'lucide-react'

import TableForContactsHistory from 'src/features/TableForContactsHistory'
import Container from 'src/components/Container'
import AppBreadcrumb from 'src/components/AppBreadcrumb'

import { useContactsHistory } from 'src/pages/ServiceContactsHistory/useContactsHistory'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/shadcn/select'
import { Input } from 'src/components/shadcn/input'
import { Button } from 'src/components/shadcn/button'
import { Badge } from 'src/components/shadcn/badge'

const ServiceContactsHistory = () => {
  const {
    locale,
    listOfSorts,
    allContactsHistory,
    isLoadingGetContacts,
    sortState,
    handleChangeSortState,
    breadcrumbItems,
    searchText,
    handleSearchChange,
    clearInput,
    inputRef,
    numberOfFoundItems,
  } = useContactsHistory()

  return (
    <Container>
      <AppBreadcrumb items={breadcrumbItems} />
      <div className="flex justify-between gap-3 mt-4">
        <div className="relative w-full">
          <Input
            ref={inputRef}
            placeholder={locale.inputPlaceholder}
            className="rounded-[10px]"
            value={searchText}
            onChange={handleSearchChange}
          />
          {searchText.length > 0 && (
            <div className="absolute top-[5px] right-1 flex flex-row gap-1 items-center">
              <Badge className="rounded-[15px] select-none h-5 w-5 text-[12px] flex items-center justify-center">
                {numberOfFoundItems}
              </Badge>
              <Button
                variant="ghost"
                className="rounded-[15px] w-8 h-8"
                onClick={clearInput}
              >
                <X />
              </Button>
            </div>
          )}
        </div>
        <Select value={sortState} onValueChange={handleChangeSortState}>
          <SelectTrigger className="lg:w-1/4 sm:w-1/2 w-full rounded-[10px]">
            <SelectValue placeholder={locale.sortStates.byNew} />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {listOfSorts.map(({ type, title }) => (
                <SelectItem key={type} value={type}>
                  {title}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      <div className="mt-5">
        <TableForContactsHistory
          allContactsHistory={allContactsHistory}
          isLoadingGetContacts={isLoadingGetContacts}
          sortState={sortState}
          handleChangeSortState={handleChangeSortState}
        />
      </div>
    </Container>
  )
}

export default ServiceContactsHistory
